// src\helper.ts
import moment from "moment";
import * as Pinia from "./store2/pinia";
// import * as Vuex from "vuex";

//
// 변수
//
// 이방식은 안됨
// export const useStore = Vuex.useStore;
export const usePinia = Pinia.useStore;

// 안됨됨
// 변수로 콜백 노출은 안되고 함수로는 되지만
// // 콜백함수에서 vue 관련 기능을 호출 할 수 없음
// type FUNC_SET_HEADERS = (url: string, headers: any) => void;
// let on_headers: FUNC_SET_HEADERS = (url, headers) => {};
// export function set_on_headers(func: FUNC_SET_HEADERS) {
//   on_headers = func;
// }

// 전역변수
let login_key = "";
let dbdate_offset = 0;
let web_doing = false;

//
// 함수
//

export function set_dbdate_offset(val: number) {
  dbdate_offset = val;
}

export function get_dbdate_offset(val: number) {
  var m = moment();
  m.add(dbdate_offset + val, "second");
  return m;
}

export function get_node_env() {
  return process.env.NODE_ENV;
}

export function is_dev() {
  if (process.env.NODE_ENV == "development") return true;
  return false;
}

// 사람이 읽을 수 있는 시간으로 표시시
export function left_to_moment(left: number) {
  return moment().add(left, "second");
}

// 정식 url head
export const canon_head = "https://apps.sidnft.com";

//
export function get_url_head() {
  if (is_dev()) {
    // return "http://localhost:4000";
    // return "https://sid123.sidnft.com:3443";
  }
  return "https://gvm.sidnft.com:3443";
}

export function from_now(text: string) {
  var m = moment(text);
  return m.fromNow();
}

// fetch 방식 웹요청
interface WEB_HEADERS {
  [key: string]: string;
}
interface WEB_REQ {
  query?: WEB_HEADERS;
  headers?: WEB_HEADERS;
  body?: any;
}
interface WEB_RES {
  status: number;
  data: any;
}

export function set_login_key(v: string) {
  console.log("set_login_key", v);
  login_key = v;
}

// get / post 공통처리
function set_headers(url: string, headers: any) {
  if (url.indexOf("http://localhost") == 0) {
  } else if (url.indexOf("https://sid123.sidnft.com") == 0) {
  } else if (url.indexOf("https://gvm.sidnft.com") == 0) {
  } else {
    // 허용하지 않는 서버 요청
    console.log("set_headers url skip", url);
    return;
  }

  //
  if (login_key) {
    console.log("set_headers login_key go", login_key);
    headers.login_key = login_key;
  } else {
    console.log("set_headers login_key skip");
  }
}

// 기다리기
export async function wait(ms: number) {
  var p = new Promise((resolve) => {
    setTimeout(resolve, ms);
  });
  return p;
}

//
export async function web_get(
  url: string,
  req: WEB_REQ = {}
): Promise<WEB_RES> {
  // console.log("web_get", url);

  while (web_doing) {
    await wait(100);
  }

  web_doing = true;

  try {
    if (req.query) {
      // console.log("query");
      const qstr = new URLSearchParams(req.query).toString();
      url += `?${qstr}`;
    }

    var headers: any = {};
    if (req.headers) {
      headers = req.headers;
    }

    // on_headers(url, headers);
    set_headers(url, headers);

    // console.log("req", url);
    const response = await fetch(url, {
      method: "GET",
      headers,
    });

    // console.log("res", response.ok);
    if (response.ok === false) {
      return {
        status: -999,
        data: {},
      };
    }

    const contentType = response.headers.get("content-type");
    // console.log("contentType", contentType);

    const status = response.status;

    let data: any = null;
    if (contentType && contentType.includes("application/json")) {
      data = await response.json();
    } else {
      data = await response.text();
    }

    console.log("web_get res", { url, status, data });
    return {
      status: 200,
      data,
    };
  } finally {
    web_doing = false;
  }
}

//
export async function web_post(url: string, req: WEB_REQ = {}) {
  // console.log("web_post", url);

  while (web_doing) {
    await wait(100);
  }

  web_doing = true;

  try {
    var headers: any = {};
    if (req.headers) {
      headers = req.headers;
    }

    // on_headers(url, headers);
    set_headers(url, headers);

    var body = {};
    if (req.body !== undefined) {
      body = req.body;
    }

    // console.log("web_post", url, body);
    var status = -999;
    var p = new Promise<WEB_RES>((resolve, reject) => {
      fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          ...headers,
        },
        body: JSON.stringify(body),
      })
        .then((response) => {
          status = response.status;
          return response.json();
        })
        .then((data) => {
          console.log("web_post", { url, status, data });
          resolve({
            status,
            data,
          });
        })
        .catch((err) => reject(err));
    });
    return await p;
  } finally {
    web_doing = false;
  }
}
